import { Box, Typography } from '@mui/material';
import { LUTIQ_COLORS, TEXT_FONT } from '../../theme';

interface LutiqLogoProps {
  /** Mark height in px; the wordmark scales with it. */
  height?: number;
  /** Dark wordmark for light backgrounds (default), or white for dark. */
  onLight?: boolean;
}

/**
 * The Lutiq three-streak mark with the approved plain-text fallback. The
 * lockup is deliberately single-color: Timing Ink on light and white/Chalk on
 * Night. Replace the fallback with the outlined wordmark asset when that
 * production artwork ships; the wordmark must never be reconstructed in a
 * display font.
 */
export function LutiqLogo({ height = 28, onLight = true }: LutiqLogoProps) {
  const w = Math.round(height * 1.25);
  const color = onLight ? LUTIQ_COLORS.ink : LUTIQ_COLORS.chalk;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', userSelect: 'none' }}>
      <svg width={w} height={height} viewBox="0 0 40 32" fill="none" aria-hidden="true">
        <line x1="4" y1="28" x2="28" y2="4" stroke={color} strokeWidth="3.5" strokeLinecap="round" />
        <line x1="12" y1="30" x2="32" y2="10" stroke={color} strokeWidth="3.5" strokeLinecap="round" />
        <line x1="20" y1="28" x2="38" y2="16" stroke={color} strokeWidth="3.5" strokeLinecap="round" />
      </svg>
      <Typography
        component="span"
        sx={{
          fontFamily: TEXT_FONT,
          fontWeight: 700,
          fontSize: `${(height * 0.05).toFixed(3)}rem`,
          letterSpacing: '-0.02em',
          lineHeight: 1,
          color,
        }}
      >
        Lutiq
      </Typography>
    </Box>
  );
}
